module.exports = __webpack_public_path__ + "media/images/city/067-national-monument-8ff8889e67c477c43dff741abdae0699.svg";